export class SignupFields {
    name: string;
    email: string;
    mobile: string;
    phone: string;
    address: string;
    agree: boolean;
}
